<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Chapter">
<p id="rw-p_133884-00001"><a id="pb-rw_xii">
</a></p><a id="pb-rw_xii">
<div class="media figure align-center width-auto" id="rw-media-figure_133884-00001">
<div class="pc"><img alt="alt" src="map.png"/>
</div>
</div>
</a><p class="fp" id="rw-p_133884-00002"><a id="pb-rw_xii"></a><a id="pb-rw_xiv">
</a></p><a id="pb-rw_xiv">
</a></div><a id="pb-rw_xiv">
</a></div><a id="pb-rw_xiv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847678164_chapter_02.vue?c3b15d16